import { Button, Col, Row } from 'reactstrap';
import { EditOptionProps } from '../../types/initiative';
import { SimpleTooltip } from '@g17eco/molecules/simple-tooltip';
import { ExchangeSetting } from '@g17eco/types/stock-exchange-settings';

const displayStockExchanges = (exchangeSettings: ExchangeSetting[]) => {
  return exchangeSettings.map((stockExchange) => stockExchange.name).join(', ');
};

export const ExchangeSettingsRow = ({ label, initiative, onClick = () => {} }: EditOptionProps) => {
  const { exchangeSettings = [] } = initiative;

  return (
    <Row className='ml-0 mb-3 mr-0 text-row__wrapper'>
      <Col className={'col-md-4 col-12 align-self-start text-label-uppercase'}>{label}</Col>
      <Col className='col-md-6 col-10 text-right text-ellipsis__paragraph'>
        {exchangeSettings.length ? (
          <SimpleTooltip text={displayStockExchanges(exchangeSettings)}>
            <span>{displayStockExchanges(exchangeSettings)}</span>
          </SimpleTooltip>
        ) : (
          <span className='text-ThemeTextPlaceholder'>not set</span>
        )}
      </Col>
      <Col className='col-2 d-flex align-self-end'>
        <Button color='link' onClick={onClick}>
          Edit
        </Button>
      </Col>
    </Row>
  );
};
